const reviewsEvents = (() => {
  const supportedLocales = [
    'en-US', 'de-DE', 'en-GB', 'fr-FR', 'es-419', 'ja-JP', 'it-IT', 'pt-BR', 'zh-CN'
  ];

  const getLocale = () => {
    const lang = getLanguage();
    return supportedLocales.includes(lang) ? lang : 'en-US';
  };

  let allReviews = [];

  const loadReviews = async () => {
    const locale = getLocale();
    try {
      const res = await fetch(`/dist/custom/js/data/reviews.${locale}.json`);
      allReviews = await res.json();
      renderReviews(allReviews);
    } catch (err) {
      console.error('Failed to load reviews:', err);
    }
  };


  const renderReviews = (reviews) => {
    const container = document.querySelector('.review-card');
    if (!container) return;

    container.innerHTML = '';

    const heading = document.createElement('h2');
    heading.className = 'faq-header-title';
    heading.textContent = getI18n('realFeedBack');


    container.appendChild(heading);


    const brandName = getBrandName();
    const shouldReplace = brandName !== 'Resume in Minutes';

    reviews.forEach(review => {
      const wrapper = document.createElement('div');
      wrapper.className = 'user-reviews';

      const text = shouldReplace
        ? review.review.replace(/Resume in Minutes/g, brandName)
        : review.review;

      wrapper.innerHTML = `
        <div class="review-header">
          <div class="review-avatar" style="border: 2px solid ${review.borderColor || '#ccc'};">
            <img src="${review.avatar}" alt="${review.username} Photo" />
          </div>
          <div class="review-name">${review.username}</div>
        </div>
        <div class="review-text">${text}</div>
      `;

      if (review.svg) {
        const svgContainer = document.createElement('div');
        svgContainer.innerHTML = review.svg;
        svgContainer.style.display = 'flex';
        svgContainer.style.justifyContent = 'center';
        svgContainer.style.marginTop = '10px';
        wrapper.querySelector('.review-text').appendChild(svgContainer);
      }

      container.appendChild(wrapper);
    });

    // Restore visibility after render
    // Restore visibility after render



  };

  const init = () => {
    loadReviews();
  };

  return { init };
})();

export default reviewsEvents;
